module.exports = __webpack_public_path__ + "img/courier-olddominion.6b9b3613.svg";